var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "custom-page" }, [
    _vm.link
      ? _c("iframe", {
          ref: "frame",
          staticClass: "custom-page-iframe",
          attrs: { src: _vm.computedUrl, frameborder: "0" },
        })
      : _c("div", { staticClass: "custom-page-not-found" }, [
          _vm._v(" " + _vm._s(_vm.$t("common.not-found")) + " "),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }